module.exports = __webpack_public_path__ + "img/ningbo_tu.91f159ed.png";